import Footer from "../../components/common/Footer";
import NavMenu from "../../components/navbar/NavMenu";
import TitleBar from "../../components/navbar/TitleBar";
import TrackAllStops from "../../components/stops/TrackAllStops";
import { Box } from "@mui/material";

export default function StopsAllTrack() {
  return (
    <>
      <TitleBar />
      <NavMenu />
      <TrackAllStops />
      <Box sx={{ height: "10vh" }}></Box>
      <Footer />
    </>
  );
}
